import React, {useState, useCallback, useEffect} from 'react';
import {useSelector} from "react-redux";
import {clone, set, throttle} from 'lodash';
import classNames from 'classnames';

const FEEDBACK_QUESTIONS = [
    'How do you feel about this new page?',
    `How excited are you to 'level up' your Mindsets Skills?`,
    'Is this new page helpful for your learning?'
];

export default function ({first_skill_data}) {
    const [popup, setPopup] = useState(false);
    const [feedback, setFeedback] = useState([null, null, null]);
    const me = useSelector(state => state.me);

    useEffect(() => {
        setTimeout(() => {
            if (!popup) {
                setPopup(true);
            }
        }, 10000);
    }, []);

    const onClickPopup = () => {
        setPopup(!popup);
    }

    const onClickFace = (question, face) => () => {
        const new_feedback = clone(feedback);
        set(new_feedback, [question], face);
        setFeedback(new_feedback);
    }

    const onSubmit = () => {
        const question_and_feedback = FEEDBACK_QUESTIONS.map((question, key) => {
            return question + ' User feedback: ' + (feedback[key] ?? 'empty' + '.');
        });
        const text = first_skill_data.school_name + ', ' + first_skill_data.state + ', ' + first_skill_data.country + '\n'
            + `Student submited feedback:\n`
            + question_and_feedback.join('\n');
        sendToSlack(text);
        setPopup(false);
    }

    const funcSendToSlack = (text) => {
        const slack_web_hook = 'https://hooks.slack.com/services/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';
        const body = {
            text
        };
        fetch(slack_web_hook, {
            method: 'POST',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            body: JSON.stringify(body)
        }).then((response) => {
            if (response.ok) {
            }
        }).catch((error) => {
            console.error('Error sending message:', error);
        });
    }
    const sendToSlack = useCallback(
        throttle(funcSendToSlack, 5000, {'trailing': false}),
        []
    );

    const renderPopup = () => {
        if (!popup) {
            return null;
        }

        const renderQuestions = () => {
            return FEEDBACK_QUESTIONS.map((question, key) => {
                return (
                    <div className="ssp-feedback-question" key={key}>
                        <div>
                            {question}
                        </div>
                        <Faces
                            question={key}
                            feedback={feedback[key]}
                            onClickFace={onClickFace}
                        />
                    </div>
                );
            });
        }

        return (
            <div className="ssp-feedback-popup">
                <div className="ssp-feedback-popup-title flex-row flex-vh-center flex-gap-5">
                    <i className="far fa-comment-alt"></i>
                    <span>{`Feedback`}</span>
                </div>

                {renderQuestions()}

                <div className="ssp-feedback-submit" onClick={onSubmit}>
                    {`OK`}
                </div>
            </div>
        );
    }

    return (
        <div className="ssp-feedback">
            <div className="ssp-feedback-trigger flex-row flex-vh-center flex-gap-5" onClick={onClickPopup}>
                <i className="far fa-comment-alt" />
                <span>{`Feedback`}</span>
            </div>

            <div className="ssp-feedback-popup-outter">
                {renderPopup()}
            </div>
        </div>
    );
}

function Faces ({question, feedback, onClickFace}) {
    const face_classnames_a = classNames(
        'far fa-meh',
        {
            'ssp-feedback-face-active': feedback === 1
        }
    );
    const face_classnames_b = classNames(
        'far fa-smile',
        {
            'ssp-feedback-face-active': feedback === 5
        }
    );
    const face_classnames_c = classNames(
        'far fa-grin-hearts',
        {
            'ssp-feedback-face-active': feedback === 10
        }
    );
    return (
        <div className="ssp-feedback-faces flex-row flex-vh-center flex-between">
            <i className={face_classnames_a} onClick={onClickFace(question, 1)} />
            <i className={face_classnames_b} onClick={onClickFace(question, 5)} />
            <i className={face_classnames_c} onClick={onClickFace(question, 10)} />
        </div>
    );
}